// in src/invoices.js
import React from 'react';
import { useMediaQuery } from '@material-ui/core';
import { List, SimpleList, Datagrid, ReferenceField } from 'react-admin';
import { Edit, EditButton, SimpleForm, ReferenceInput, TextInput, SelectInput } from 'react-admin';
import { Show, ShowButton, SimpleShowLayout } from 'react-admin';
import { TextField, DateField, NumberField } from 'react-admin';
import { Create } from 'react-admin';
import { Filter } from 'react-admin';
import { ChipField, ReferenceManyField, SingleFieldList } from 'react-admin';


const InvoiceFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        {/*
        <ReferenceInput label="Contact" source="compId" reference="comps" allowEmpty>
            <SelectInput optionText="name" />
        </ReferenceInput>
        */}
    </Filter>
);

export const InvoiceList = props => {
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));

    return (
        <List filters={<InvoiceFilter/>} {...props}>
            {(
                !!isSmall 
                ? (
                    <SimpleList
                        primaryText={record => `INV${record.id}`}
                        secondaryText={record => `${parseFloat(record.amount).toFixed(2)}`}
                        tertiaryText={record => new Date(record.date).toLocaleDateString()}
                    />
                )
                : (  
                    
                    <Datagrid rowClick="show">
                        <TextField source="date" />
                        <TextField source="id" />
                        <NumberField source="amount" options={{ style: 'currency', currency: 'GBP' }}/>
                        {/* <ShowButton /> */}
                    </Datagrid>
                )
            )}
        </List>
    );
};

export const InvoiceShow = ({invoice, ...props}) => {
//    const dataProvider = useDataProvider();
//    const [comp, setComp] = useState();
//    const [loading, setLoading] = useState(true);
//    const [error, setError] = useState();
//    useEffect(() => {
//        dataProvider.getManyByReference('invoice/component', { invoice })
//            .then(({ data }) => {
//                setComp(data);
//                setLoading(false);
//            })
//            .catch(error => {
//                setError(error);
//                setLoading(false);
//            })
//    }, []);
//
//    if (loading) return <Loading />;
//    if (error) return <Error />;
//    if (!comp) return null;

    return (
        <Show title={<InvoiceTitle />}  {...props}>
            <SimpleShowLayout>
                <TextField source="id" />
                <TextField source="name" />
                <TextField source="amount" />
                <ReferenceManyField label="Contents" reference="invoice/component" target="invoice">
                <Datagrid>
                    <DateField source="date" />
                    <TextField source="code" />
                    <TextField source="name" />
                    <NumberField source="amount" options={{ style: 'currency', currency: 'GBP' }}/>
                </Datagrid>
                </ReferenceManyField>
            </SimpleShowLayout>
        </Show>
    )
};

export const InvoiceEdit = props => (
    <Edit title={<InvoiceTitle />}  {...props}>
        <SimpleForm>
            <TextInput disabled source="id" />
            <ReferenceInput source="compId" reference="comps">
                <SelectInput optionText="name" />
            </ReferenceInput>
            <TextInput source="title" />
            <TextInput multiline source="body" />
        </SimpleForm>
    </Edit>
);

export const InvoiceCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <ReferenceInput source="compId" reference="comps">
                <SelectInput optionText="name" />
            </ReferenceInput>
            <TextInput source="title" />
            <TextInput multiline source="body" />
        </SimpleForm>
    </Create>
);

const InvoiceTitle = ({ record }) => {
    return <span>Invoice {record ? `${record.id}` : ''}</span>;
};


// WEBPACK FOOTER //
// ./src/Invoice.js